"use client";

import { useI18n } from "@/i18n/client";
import IconFile from "@/app/assets/images/svg/file.svg";
import styles from "./Documentation.module.scss";

interface DocumentProps {
	file_url: string;
	file_name: string;
}

const Document: React.FC<DocumentProps> = ({ file_url, file_name }) => {
	const t = useI18n();

	return (
		<div className={styles.document}>
			<IconFile />
			<div>
				<h5>{file_name}</h5>
				<a href={`${file_url}`}>
					{t("text.download")} {file_name}
				</a>
			</div>
		</div>
	);
};

export default Document;
